import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import { sampleProducts, clouds } from '../../../components/product.js';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const ProductCardGrid = makeShortcode("ProductCardGrid");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <TitleBlock slots="heading, text" theme="lightest" className="titleBlock-align-left pt-grid-title-padding-bottom link linking" mdxType="TitleBlock" />
    <h2 {...{
      "id": "download-sample-templates-and-data-to-get-started"
    }}>{`Download sample templates and data to get started`}</h2>
    <p>{`Review our sample Word templates with JSON data and `}<a parentName="p" {...{
        "href": "https://acrobatservices.adobe.com/dc-docgen-playground/index.html#/"
      }}>{`try the demo.`}</a></p>
    <TextBlock slots="buttons" width="100%" theme="lightest" isCentered className="padding-zero ms-word-add-in-title" mdxType="TextBlock" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/document-generation-api/wordaddin/"
        }}>{`Get Microsoft Word add-in`}</a></li>
    </ul>
    <ProductCardGrid clouds={clouds} products={sampleProducts} showName={true} showDescription={false} interaction={false} buttonName="Download" showBorder={false} imgHeight="1300" imgWidth="1500" isCentered={true} theme="lightest" className="padding-bottom-zero productCardGrid" containerWidth="950px" id="sample-blade" mdxType="ProductCardGrid" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      